/* eslint-disable react/no-typos */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { GenericCheckbox } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Field } from 'react-final-form';
import { isCheck } from '../../../../utils/validation';

class SearchSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggleDropDown: false, searchValue: '' };
    this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this);
    this.toggleOnOutsideClick = this.toggleOnOutsideClick.bind(this);
    document.addEventListener('click', this.toggleOnOutsideClick);
  }
  getSelectedItemsCount() {
    const count = this.props.selectedItems.length;
    if (count) {
      return ` (${count})`;
    }
    return false;
  }
  handleSearchFieldChange({ value }) {
    this.setState({ searchValue: value });
  }
  handleCheckboxClick(country) {
    const { selectedSearchItems } = this.props;
    selectedSearchItems(country);
  }
  renderItems() {
    const { searchItems, id, selectedItems } = this.props;
    const { searchValue } = this.state;
    const filterItems = searchValue
      ? searchItems.filter(
          item => item.labelText.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
        )
      : searchItems;
    return (
      <GenericCheckbox.StackedSet
        items={filterItems}
        onChange={selectedIds => {
          this.handleCheckboxClick(selectedIds);
        }}
        selectedIds={selectedItems || []}
        groupName={id}
      />
    );
  }
  toggleOnOutsideClick(evt) {
    const selectElement = document.getElementById(this.props.id);
    let targetElement = evt.target;
    if (
      targetElement.classList.toString().indexOf('has-suffix') > 0 ||
      targetElement.classList.toString().indexOf('c-m-search-and-select__item') >= 0
    ) {
      this.setState({ toggleDropDown: false });
    }
    do {
      if (targetElement === selectElement) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
    this.setState({ toggleDropDown: false });
  }
  render() {
    const {
      label,
      searchPlaceholder,
      children,
      id,
      accordionLabel,
      supplement,
      fieldValidation,
      helpText
    } = this.props;
    const { toggleDropDown } = this.state;
    const selectSearchClassNames = classnames('c-m-search-and-select', {
      'c-m-search-and-select--dropdown-visible': toggleDropDown
    });
    let shouldValidate;
    if (this.getSelectedItemsCount() === false) {
      shouldValidate = isCheck;
    }
    return (
      <Field name={id} subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId={id}
            title={label}
            supplement={supplement}
            validationMessage={touched && !!error ? fieldValidation : ''}
            description={helpText}
          >
            <div hasError={touched && !!error}>
              <Field name={id} component="select" validate={shouldValidate}>
                {() => (
                  <div className={selectSearchClassNames} id={id}>
                    <div className="c-m-search-and-select__selector">
                      <div
                        tabIndex="0"
                        className="c-m-search-and-select__dropdown"
                        role="button"
                        onClick={() => this.setState({ toggleDropDown: !toggleDropDown })}
                      >
                        <span className="c-m-search-and-select__dropdown-value">
                          {accordionLabel}
                          <span className="c-m-search-and-select__dropdown-count">
                            {this.getSelectedItemsCount()}
                          </span>
                        </span>
                        <span className="c-m-search-and-select__dropdown-icon">
                          {toggleDropDown ? (
                            <Icon iconType="ChevronUpSolidSmall" size="sm" />
                          ) : (
                            <Icon iconType="ChevronDownSolidSmall" size="sm" />
                          )}
                        </span>
                      </div>
                      <div className="c-m-search-and-select__toggle-content">
                        <div className="c-m-search-and-select__search-field">
                          <Input
                            type="text"
                            className="c-a-input"
                            id={id}
                            name={id}
                            placeholder={searchPlaceholder}
                            onChange={e => this.handleSearchFieldChange(e.target)}
                          />
                        </div>
                        <div className="c-m-search-and-select__options">{this.renderItems(id)}</div>
                      </div>
                    </div>
                    {children}
                  </div>
                )}
              </Field>
            </div>
          </GenericFieldWrapper>
        )}
      </Field>
    );
  }
}

SearchSelect.propTypes = {
  searchItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isCheck,
      accordionLabel: PropTypes.string.isCheck,
      isChecked: PropTypes.bool
    })
  ).isCheck,
  accordionLabel: PropTypes.string.isCheck,
  searchPlaceholder: PropTypes.string.isCheck,
  selectedSearchItems: PropTypes.func,
  children: PropTypes.node
};

export default SearchSelect;
